import { getImageStyles } from './variantStyles/image';
import { getPrimaryStyles } from './variantStyles/primary';
import { getPrimaryOnPageStyles } from './variantStyles/primaryOnPage';
import { getSecondaryStyles } from './variantStyles/secondary';
import { getSecondaryOnPageStyles } from './variantStyles/secondaryOnPage';
import { getTertiaryStyles } from './variantStyles/tertiary';
import { getTertiaryOnPageStyles } from './variantStyles/tertiaryOnPage';
export const getQuickButtonComplexStyles = (FOUNDATIONS, FONT) => {
    return {
        ...getPrimaryStyles(FOUNDATIONS, FONT),
        ...getPrimaryOnPageStyles(FOUNDATIONS, FONT),
        ...getSecondaryStyles(FOUNDATIONS, FONT),
        ...getSecondaryOnPageStyles(FOUNDATIONS, FONT),
        ...getTertiaryStyles(FOUNDATIONS, FONT),
        ...getTertiaryOnPageStyles(FOUNDATIONS, FONT),
        ...getImageStyles(FOUNDATIONS, FONT),
    };
};
//# sourceMappingURL=styles.js.map